import bookWhoIsNemos from '../img/shop/book-who-is-nemos.jpg';
import bookWhoIsNemosDetail1 from '../img/shop/book-who-is-nemos-detail1.jpg';
import bookWhoIsNemosDetail2 from '../img/shop/book-who-is-nemos-detail2.jpg';
import bookWhoIsNemosDetail3 from '../img/shop/book-who-is-nemos-detail3.jpg';
import bookWhoIsNemosDetail4 from '../img/shop/book-who-is-nemos-detail4.jpg';
import bookWhoIsNemosDetail5 from '../img/shop/book-who-is-nemos-detail5.jpg';
import bookH2o from '../img/shop/book-h2o.jpg';
import bookH2oDetail1 from '../img/shop/book-h2o-detail1.jpg';
import bookH2oDetail2 from '../img/shop/book-h2o-detail2.jpg';
import bookH2oDetail3 from '../img/shop/book-h2o-detail3.jpg';
import bookH2oDetail4 from '../img/shop/book-h2o-detail4.jpg';
import bookH2oDetail5 from '../img/shop/book-h2o-detail5.jpg';
import printSgombero from '../img/shop/print-sgombero.jpg';
import printSgomberoDetail1 from '../img/shop/print-sgombero-detail1.jpg';
import printSgomberoDetail2 from '../img/shop/print-sgombero-detail2.jpg';
import printSgomberoDetail3 from '../img/shop/print-sgombero-detail3.jpg';
import printSgomberoDetail4 from '../img/shop/print-sgombero-detail4.jpg';
import printSgomberoDetail5 from '../img/shop/print-sgombero-detail5.jpg';
import printBeYourCar from '../img/shop/print-be-your-car.jpg';
import logosPrintCalvario from '../img/shop/logos-print-calvario.jpg';
import logosPrintEdifeci from '../img/shop/logos-print-edifeci.jpg';
import logosPrintFeed from '../img/shop/logos-print-feed.jpg';
import logosPrintHArm from '../img/shop/logos-print-h-arm.jpg';
import logosPrintLight from '../img/shop/logos-print-light.jpg';
import logosPrintOrientation from '../img/shop/logos-print-orientation.jpg';
import logosPrintPerMano from '../img/shop/logos-print-per-mano.jpg';
import logosPrintSalvadanaio from '../img/shop/logos-print-salvadanaio.jpg';
import logosPrintSelfieHarakiri from '../img/shop/logos-print-selfie-harakiri.jpg';
import logosPrintSpacciatore from '../img/shop/logos-print-spacciatore.jpg';
import tekeArataima from '../img/shop/teke-arataima.jpg';
import tekeFumMO from '../img/shop/teke-fum-m-o.jpg';
import tekeKEyes from '../img/shop/teke-k-eyes.jpg';
import tekeLetame from '../img/shop/teke-letame.jpg';
import tekeLosAngeles from '../img/shop/teke-los-angeles.jpg';
import sculpture1 from '../img/shop/sculpture-1.jpg';
import sculpture2 from '../img/shop/sculpture-2.jpg';
import sculpture3 from '../img/shop/sculpture-3.jpg';
import sculpture4 from '../img/shop/sculpture-4.jpg';
import sculpture5 from '../img/shop/sculpture-5.jpg';

import { Image } from './Image';

export type Section = {
  name: string;
  launched: boolean;
  layout: 'wide' | 'grid';
  products: ShopProduct[];
};

export type ShopProduct = WooCommerceProduct | ExternalProduct;

export type WooCommerceProduct = AbstractProduct & {
  woocommerceId: number;
};

export type ExternalProduct = AbstractProduct & {
  externalTitle: string;
  externalUrl: string;
};

type AbstractProduct = {
  id: string;
  title: string;
  images: Image[];
  details: ProductDetails;
};

export type ProductDetails = {
  [key: string]: string;
};

export class ShopProducts {
  getSections(): Section[] {
    return [
      {
        name: 'Books',
        launched: true,
        layout: 'wide',
        products: [
          {
            id: 'book-whoisnemos',
            title: "Who Is NemO'S",
            images: [
              { alt: "Who Is Nemo's Cover", src: bookWhoIsNemos },
              { alt: "Who Is Nemo's Page", src: bookWhoIsNemosDetail1 },
              { alt: "Who Is Nemo's Page", src: bookWhoIsNemosDetail2 },
              { alt: "Who Is Nemo's Page", src: bookWhoIsNemosDetail3 },
              { alt: "Who Is Nemo's Page", src: bookWhoIsNemosDetail4 },
              { alt: "Who Is Nemo's Page", src: bookWhoIsNemosDetail5 },
            ],
            details: {
              Year: '2016',
              Pages: '176',
              Size: '19x23.5cm / 7.5"x9.25"',
              Price: '15.00€',
            },
            externalTitle: 'Buy on libri.it',
            externalUrl: 'https://www.libri.it/who-is-nemo-s?tag=NemO%27s',
          },
          {
            id: 'book-h2o',
            title: 'H2O',
            images: [
              { alt: 'H2O Cover', src: bookH2o },
              { alt: 'H2O Page', src: bookH2oDetail1 },
              { alt: 'H2O Page', src: bookH2oDetail2 },
              { alt: 'H2O Page', src: bookH2oDetail3 },
              { alt: 'H2O Page', src: bookH2oDetail4 },
              { alt: 'H2O Page', src: bookH2oDetail5 },
            ],
            details: {
              Year: '2017',
              Pages: '15 prints',
              Size: '24x34cm / 9.4"x13.4"',
              Price: '15.00€',
            },
            externalTitle: 'Buy on libri.it',
            externalUrl: 'https://www.libri.it/h2o?tag=NemO%27s',
          },
        ],
      },
      {
        name: 'Screen Prints',
        launched: false,
        layout: 'grid',
        products: [
          {
            id: 'print-sgombero',
            title: 'Sgombero',
            images: [
              { alt: 'Sgombero', src: printSgombero },
              { alt: 'Sgombero detail', src: printSgomberoDetail1 },
              { alt: 'Sgombero detail', src: printSgomberoDetail2 },
              { alt: 'Sgombero detail', src: printSgomberoDetail3 },
              { alt: 'Sgombero detail', src: printSgomberoDetail4 },
              { alt: 'Sgombero detail', src: printSgomberoDetail5 },
            ],
            details: {
              Print: 'Screen print',
              Paper: '?', // TODO
              Size: '?', // TODO
              'Printed by': '?', // TODO
              Price: '?', // TODO
            },
            woocommerceId: 21,
          },
          {
            id: 'print-be-your-car',
            title: 'Be Your Car',
            images: [{ alt: 'Be Your Car', src: printBeYourCar }],
            details: {
              Print: 'Screen print',
              Paper: '?', // TODO
              Size: '?', // TODO
              'Printed by': '?', // TODO
              Price: '?', // TODO
            },
            woocommerceId: 82,
          },
        ],
      },
      {
        name: 'Digital Prints',
        launched: true,
        layout: 'grid',
        products: [
          {
            id: 'print-logos',
            title: 'Logos Prints',
            images: [
              { src: logosPrintEdifeci, alt: 'Edifeci' },
              { src: logosPrintSelfieHarakiri, alt: 'Selfie Harakiri' },
              { src: logosPrintFeed, alt: 'Feed' },
              { src: logosPrintCalvario, alt: 'Calvario' },
              { src: logosPrintPerMano, alt: 'Per Mano' },
              { src: logosPrintHArm, alt: 'H-Arm' },
              { src: logosPrintLight, alt: 'Light' },
              { src: logosPrintOrientation, alt: 'Orientation' },
              { src: logosPrintSalvadanaio, alt: 'Salvadanaio' },
              { src: logosPrintSpacciatore, alt: 'Spacciatore' },
            ],
            details: {
              Print: 'Digital',
              Paper: 'Faviri Shiro Echo White 250gr',
              Size: 'A3 / 29.7x42cm / 11.7"x16.5"',
              'Printed by': 'Fina Estampa',
              Price: '30.00€',
            },
            externalTitle: 'Buy on libri.it',
            externalUrl:
              'https://www.libri.it/index.php?route=product/search&search=NemO%27S&category_id=264',
          },
        ],
      },
      {
        name: 'Original Drawings',
        launched: true,
        layout: 'wide',
        products: [
          {
            id: 'drawings',
            title: 'Drawings',
            images: [
              { src: tekeArataima, alt: 'Arataima' },
              { src: tekeKEyes, alt: 'K-Eyes' },
              { src: tekeFumMO, alt: 'Fum(m)o' },
              { src: tekeLosAngeles, alt: 'Los Angeles' },
              { src: tekeLetame, alt: 'Letame' },
            ],
            details: {},
            externalTitle: 'Ask for price',
            externalUrl:
              "mailto:info@whoisnemos.com?subject=Price%20inquiry&body=Hi%0AI'm%20interested%20in%20...",
          },
        ],
      },
      {
        name: 'Sculptures',
        launched: false,
        layout: 'wide',
        products: [
          {
            id: 'sculpture',
            title: 'Sculpture',
            images: [
              { alt: 'Sculpture', src: sculpture1 },
              { alt: 'Sculpture', src: sculpture2 },
              { alt: 'Sculpture', src: sculpture3 },
              { alt: 'Sculpture', src: sculpture4 },
              { alt: 'Sculpture', src: sculpture5 },
            ],
            details: {
              Year: '2020',
            },
            woocommerceId: 10,
          },
        ],
      },
      // TODO: Stickers, Postcards, Pins, Commissions
    ];
  }
}
